import { useState } from "react"
import { getListaDetById, postListaDet, patchListaDet } from "../../services/ListaDetServices"
import { getArticuloById } from "../../services/ArticulosServices";
import { ListasDetFormContext } from "./ListasDetContext"
import { useNavigate} from 'react-router-dom';
//import { Color } from '../../routes/RoutesConstants'

export const ListasDetFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();

    const getListaDetByIdData = async (art_id, lp_id) => { 
        let res = await getListaDetById(art_id, lp_id)
        if (res) setReport(res)
        return res
    }

    const postListaDetData = async (body) => {
        const res = await postListaDet(body)
        if (res) navigate("/listasdet");
    }

    const patchListaDetData = async (art_id, lp_id, body) => {
        
        const res = await patchListaDet(art_id, lp_id, body);
        if (res) {
            // Verifica si `body.ofcad` está disponible y redirige a la nueva ruta
            if (res.data.ofcab_id) {
                navigate(`/listas/new/${res.data.ofcab_id}`);
            } else {
                
                navigate("/listas");
            }
        }
    };
    

    const getArticuloByIdData = async (id) => {
        try {
            let res = await getArticuloById(id);
            return res;
        } catch (error) {
            console.error("Error obteniendo artículo por ID:", error);
            return null;
        }
    };

    return <ListasDetFormContext.Provider value={{
        report,
        getListaDetByIdData,
        postListaDetData,
        patchListaDetData,
        getArticuloByIdData,

    }} >
        {children}
    </ListasDetFormContext.Provider>
}